import React from 'react';
import { Flex } from '@atlaskit/primitives/compiled';
import type { UIAnalyticsEvent as AnalyticsEvent } from '@atlaskit/analytics-next';
import type { User } from '@atlassian/jira-common-directory-v2/src/model/index.tsx';
import Actions from '../actions/view.tsx';
import Popularity from '../popularity/view.tsx';

type Props = {
	popularity: number | undefined;
	manageSubscriptionsUrl: string;
	name: string | undefined;
	owner: User | null | undefined;
	atlassianAccountId: string | undefined;
	isCopyFilterModalOpen: boolean;
	isWritable: boolean;
	isAdmin: boolean;
	filterId: string;
} & {
	showSpinner: boolean;
	onEdit: (arg1: AnalyticsEvent) => void;
	onDelete: (arg1: AnalyticsEvent) => void;
	onCopy: (arg1: AnalyticsEvent) => void;
	onChangeOwner: (arg1: AnalyticsEvent) => void;
};

export default function PopularityWithTypeActions(props: Props): React.JSX.Element {
	const { popularity } = props;

	return (
		<Flex alignItems="center" justifyContent="space-between">
			<Popularity popularity={popularity} />
			<Actions {...props} />
		</Flex>
	);
}
